(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logistow-gallery-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.lo-gallery');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach((s) => s.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed')));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const order = parseInt(entry.target.dataset.revealOrder || '0', 10);
          const delay = Math.min(order * 60, 480);
          entry.target.style.setProperty('--reveal-delay', delay);
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    sections.forEach((s) => s.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logistow-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.lo-hero');
    if (!sections.length) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach((s) => s.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed')));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const order = parseInt(entry.target.dataset.revealOrder || '0', 10);
          entry.target.style.setProperty('--reveal-delay', order * 160);
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    sections.forEach((s) => s.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
